import React, { Component } from 'react'
import { createAcknowledgement, toggleModal } from 'actions/acknowledgements'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import language from 'utils/vast-languagepack'

export default connect(
  (state, { match }) => ({
    // acknowledgedContactMethod: state.acknowledgement.acknowledgedContactMethod,
    open: state.acknowledgement.modalOpen,
    acknowledgementText: state.acknowledgement.acknowledgementText,
    contactMethod: state.acknowledgement.contactMethod,
    username:
      state.auth &&
      state.auth.session &&
      state.auth.session.accessToken &&
      state.auth.session.accessToken.payload &&
      state.auth.session.accessToken.payload.username,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        createAcknowledgement,
        toggleModal,
      },
      dispatch,
    ),
)(
  withMobileDialog()(
    class Acknowledgement extends Component {
      render() {
        const {
          open,
          acknowledgementText,
          contactMethod,
          createAcknowledgement,
          callBack,
          toggleModal,
        } = this.props

        return (
          <Dialog
            fullScreen={false}
            open={open}
            aria-labelledby="responsive-dialog-title"
            style={{ borderRadius: 22 }}
          >
            <DialogTitle id="responsive-dialog-title">
              Acknowledgement
            </DialogTitle>
            <DialogContent>
              <DialogContentText>{acknowledgementText}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={() => toggleModal({ modalOpen: false })}
                color="secondary"
              >
                {language.s3Manager.neverMind}
              </Button>
              <Button
                onClick={() => {
                  createAcknowledgement(
                    acknowledgementText,
                    contactMethod,
                  ).then(
                    () => {
                      toggleModal({ modalOpen: false })
                      callBack('created')
                    },
                    (err) => {
                      toggleModal({ modalOpen: false })
                    },
                  )
                }}
                color="primary"
              >
                {language.s3Manager.confirm}
              </Button>
            </DialogActions>
          </Dialog>
        )
      }
    },
  ),
)
